module.exports = __webpack_public_path__ + "static/media/teammember3.6be5b461.jpeg";